export default __webpack_public_path__ + "static/media/bg.9b90d46a.png";